/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EventManagementListEventResponse } from './EventManagementListEventResponse';

export type EventManagementListEventResponseApiRespoonse = {
    data?: EventManagementListEventResponse;
    status?: EventManagementListEventResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace EventManagementListEventResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

